import React from 'react';
import CardJugador from '../CardJugador/CardJugador';

const LineasSVG = () => (
  <svg
    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1, pointerEvents: 'none' }}
    viewBox="0 0 100 150" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="3" width="94" height="144" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <line x1="3" y1="75" x2="97" y2="75" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <circle cx="50" cy="75" r="12" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <circle cx="50" cy="75" r="0.8" fill="rgba(255,255,255,0.6)"/>
    <rect x="22" y="118" width="56" height="29" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <rect x="36" y="132" width="28" height="15" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <rect x="42" y="146" width="16" height="3" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <circle cx="50" cy="128" r="0.8" fill="rgba(255,255,255,0.6)"/>
    <path d="M 34 118 A 16 16 0 0 1 66 118" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <rect x="22" y="3" width="56" height="29" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <rect x="36" y="3" width="28" height="15" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <rect x="42" y="1" width="16" height="3" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
    <circle cx="50" cy="22" r="0.8" fill="rgba(255,255,255,0.6)"/>
    <path d="M 34 32 A 16 16 0 0 0 66 32" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.5"/>
  </svg>
);

const CanchaGrid = ({
  posiciones,
  equipo,
  slotSeleccionado,
  onClickSlot,
  infoBar,
  jugadoresDestacados = null,
  capitanIndex = null,
  onCapitan = null,
  puntajeJugador = {},
}) => {
  return (
    <main className="pitch-panel-compact">
      <div className="pitch-info-bar">{infoBar}</div>
      <div className="pitch-container-compact">
        <LineasSVG />
        {posiciones.map((p, i) => {
          const jugador = equipo[i];
          const opacado = jugadoresDestacados !== null && jugador
            ? !jugadoresDestacados.includes(jugador.id)
            : false;
          return (
            <div
              key={i}
              className={`player-card-position
                ${slotSeleccionado !== null && slotSeleccionado !== i ? 'slot-dimmed' : ''}
                ${slotSeleccionado === i ? 'slot-selected' : ''}
              `}
              style={{
                gridRow: p.fila, gridColumn: p.col,
                ...(opacado ? { opacity: 0.25, transition: 'opacity 0.2s ease' } : {}),
              }}
              onClick={(e) => onClickSlot(e, i, p.pos)}
              onContextMenu={(e) => { e.preventDefault(); if (onCapitan) onCapitan(i); }}
            >
              <div className="card-cancha-wrap">
                <CardJugador
                  jugador={jugador}
                  posicion={p.pos}
                  estado="LOCAL"
                  esCapitan={capitanIndex === i}
                  puntos={jugador ? (puntajeJugador[jugador.id] ?? null) : null}
                />
                {jugador && (
                  <span className="card-nombre-ext">
                    {jugador.apellido
                      ? `${jugador.apellido}${jugador.nombre ? ` ${jugador.nombre.charAt(0)}.` : ''}`
                      : jugador.nombre || '?'}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </main>
  );
};

export default CanchaGrid;